import { sendAccountEmailVerification, verifyAccountEmailCode } from "@vetty/api-sdk";
import { axiosInstance } from "@/helpers";

export const sendAccountEmailVerificationCodeRequest = async (): Promise<void> => {
  await sendAccountEmailVerification(axiosInstance);
};

export const verifyAccountEmailCodeRequest = async (code: string): Promise<void> => {
  await verifyAccountEmailCode(axiosInstance, { code });
};
